import React, {Component} from "react";
import {hideHeader} from "../../../actions/actionCreators";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import i18n from "../../../i18nextInitiator";
import rulesImg from "./rule.png"
import NavigationButtons from "./NavigationButtons";
import Grid from "@material-ui/core/Grid";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
const styles = (theme) => ({
    root: {
        background: "url('/orders/images/main-bg.png')"
    },
    secondRoot: {
        maxWidth: 600,
        padding: "20px",
        margin: "0 auto",
        "& img": {
            width: "100%"
        }
    },
    rulesPaper: {
        padding: 20,
        "& ul": {
            listStyleType: 'none',
            paddingInlineStart: 0
        }
    }
});

class NowrouzGameRules extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        hideHeader()
    }

    render() {
        const {
            props: {
                classes
            },
            state: {
                rows
            } = {}
        } = this

        return <div className={classes.root}>
            <div className={classes.secondRoot}>
                <Grid container justifyContent={"center"}>
                    <img style={{width: "100%"}} alt="prizes" src={rulesImg}/>
                </Grid>
                <Paper className={classes.rulesPaper}>
                        <ul>
                            <Typography variant={"h6"}>
                                {Array(8).fill("rule")
                                    .map((text, index) => <li key={index}>{t(`nowrouz-game.rules.${index}`)}</li>)}
                            </Typography>
                        </ul>
                </Paper>
                <NavigationButtons/>
            </div>
        </div>
    }
}

export default withStyles(styles)(NowrouzGameRules);